import recordStore from "@/store/record.store";
import { IBackTrace, IFormatBackTrace, IPG } from "@/types/summary";

export const formatBackTraceData = (backTraceData: IBackTrace) => {
  const records = recordStore.getState().records;
  console.log("formatBackTraceData records len", records.length);
  if (!records.length) return;
  const recordPiArr = records.map((record) => record.pi);

  const result = backTraceData
    ? formatBackTrace(backTraceData, recordPiArr, records)
    : [];
  console.log("formatBackTraceData result", result);
  return result;
};

export const formatBackTrace = (
  data: IBackTrace,
  recordPiArr: string[],
  records: IPG[]
) => {
  try {
    const copyData = JSON.parse(JSON.stringify(data)) as IFormatBackTrace;
    Object.keys(copyData).map((key) => {
      const innerArray = data[key];
      copyData[key] = mergeConsecutiveItems(
        innerArray
          .flatMap((obj) => {
            const pi = Object.keys(obj)[0];
            const pIndex = recordPiArr.indexOf(pi);
            const siArr = records[pIndex]?.sc?.map((item) => item.si) || [];
            const value = obj[pi];
            return value.si.map((sId) => {
              const sIndex = siArr.indexOf(sId);
              return {
                sIndex,
                sId,
                pi,
                pIndex,
              };
            });
          })
          .filter((item) => item.pIndex >= 0)
          .sort((a, b) => a.pIndex - b.pIndex)
      );
    });
    return copyData;
  } catch (error) {
    console.log("formatBackTrace log", error);
  }
};

// 合并连续的 sIndex 项，并将 sId 合并成新数组
const mergeConsecutiveItems = (
  array: { sIndex: number; sId: string; pi: string; pIndex: number }[]
) => {
  if (array.length === 0) return [];

  const result = [];
  let currentGroup = {
    sIndex: array[0].sIndex,
    pIndex: array[0].pIndex,
    sIds: [array[0].sId],
    pi: array[0].pi,
  };

  for (let i = 1; i < array.length; i++) {
    const currentItem = array[i];

    // 检查当前项的 sIndex 是否与前一项的 sIndex 连续
    if (currentItem.sIndex === currentGroup.sIndex + currentGroup.sIds.length) {
      // 如果连续，则将当前项的 sId 添加到当前组的 sIds 数组中
      currentGroup.sIds.push(currentItem.sId);
    } else {
      // 如果不连续，则将当前组添加到结果数组中，并开始新的组
      result.push(currentGroup);
      currentGroup = {
        sIndex: array[0].sIndex,
        pIndex: currentItem.pIndex,
        sIds: [currentItem.sId],
        pi: currentItem.pi,
      };
    }
  }

  // 将最后一个组添加到结果数组中
  result.push(currentGroup);

  return result;
};
